export function familySchedulePath() {
  return '/family/schedule'
}
